import dayjs from 'dayjs'

import { FirmDashboardAmount, FirmDashboardCount } from '../../../../generated'
import { CHART_PALETTE } from '../cases/caseCharts/constants'

/** Range dates travel as calendar days; the API reads them as ET days. */
export const RANGE_DATE_FORMAT = 'YYYY-MM-DD'

/** Last 30 days, today included. */
export const getDefaultRange = () => ({
  startDate: dayjs().subtract(29, 'day').format(RANGE_DATE_FORMAT),
  endDate: dayjs().format(RANGE_DATE_FORMAT)
})

export const formatRangeLabel = (startDate: string, endDate: string) =>
  `${dayjs(startDate).format('MM/DD/YYYY')} – ${dayjs(endDate).format('MM/DD/YYYY')}`

/** A card subtitle followed by the date range its figures cover. */
export const withRange = (subtitle: string, rangeLabel: string) => `${subtitle.replace(/\.$/, '')} (${rangeLabel})`

/** Every dashboard chart is a single series, so it is drawn in one color. */
export const DASHBOARD_BAR_COLOR = CHART_PALETTE.red

/** Matter status charts, in bar order: every matter, then its split into Active and Completed (Work Completed + Closed). */
export const MATTER_STATUS_SERIES = [
  { key: 'count', label: 'Total', color: DASHBOARD_BAR_COLOR },
  { key: 'active', label: 'Active', color: CHART_PALETTE.amber },
  { key: 'completed', label: 'Completed', color: CHART_PALETTE.neutralLight }
] as const

/** Month-over-month incoming chart, in series order: 1031 (trust), 1036 (operating). */
export const INCOMING_FLOW_COLORS = [CHART_PALETTE.amber, CHART_PALETTE.red]

export const formatMonthLabel = (month: string) => dayjs(`${month}-01`).format('MMM YYYY')

export const formatCount = (value: number) => value.toLocaleString('en-US')

export const toCountBars = (rows?: FirmDashboardCount[]) => rows?.map(({ label, count }) => ({ label, value: count }))

export const toAmountBars = (rows?: FirmDashboardAmount[]) =>
  rows?.map(({ label, amount }) => ({ label, value: amount }))

/** Card subtitles ("As of today", the date range) — lighter than the theme's body2 (16px / 500). */
export const CARD_SUBTITLE_SX = { fontSize: '13px', fontWeight: 400 }
